import {Helmet} from "react-helmet";
import {RouteHelper} from "../../route/RouteHelper";
import {
    addNewRowToTable,
    convertUniversalDateToPersianDate, DialogSize,
    RaikoBaseCardContainer,
    RaikoBaseContainer,
    RaikoBreadcrumb,
    raikoBreadCrumbItemGenerator,
    RaikoCardInfoTypeOne,
    RaikoCardInfoTypeOneItemGenerator, RaikoCardInfoTypeOneStatusTypes,
    RaikoChipTypes, RaikoCustomSelect, raikoCustomSelectItemGenerator,
    RaikoCustomSimpleChip,
    RaikoCustomTable, RaikoDefaultDialogPage,
    RaikoGridOneColumn, RaikoGridThreeColumn, RaikoTableSearchContainer,
    RaikoTableTitleContainer, showServerErrorMessage
} from "@moeindal/base-raiko-panel-components";
import React, {useEffect, useState} from "react";
import {css} from "@emotion/css";
import gameThumbnail from "../../assets/svg/thumbnail.svg"
import {GameService} from "../../serverService/gameService/GameService";
import {useDebounce} from "@uidotdev/usehooks";
import AddNewGame from "../../component/addNewGame/AddNewGame";
import {useNavigate} from "react-router-dom";
import {GameStatusTypes, getGameStatus} from "./GameStatusTypes";
import {PlayModeTypes} from "./PlayModeTypes"

export default function Games() {

    let page = 0;
    const size = 20;

    const [numberOfItems, setNumberOfItems] = useState(0);
    const [tableLoading, setTableLoading] = useState(false);
    const [pageCount, setPageCount] = useState(0);
    const [gameListData, setGameListData] = useState([]);
    const [gameTitle, setGameTitle] = useState("");
    const [status, setStatus] = useState(GameStatusTypes.ALL.id);
    const [playMode, setPlayMode] = useState(PlayModeTypes.ALL.id)


    const _gameTitleFilter = useDebounce(gameTitle, 500);
    const _statusTitleFilter = useDebounce(status, 100);
    const _playModeFilter = useDebounce(playMode, 100)

    useEffect(() => {
        if (typeof service !== 'undefined') {
            getGamesListFromServer()
        }
    }, [_gameTitleFilter, _statusTitleFilter, _playModeFilter]);

    const service = new GameService()

    const [selectDisplayType, setSelectDisplayType] = useState(false)

    function getGamesListFromServer() {
        setTableLoading(true)
        service.getGameList(page, size, _gameTitleFilter, _playModeFilter, _statusTitleFilter)
            .then(response => {
                setPageCount(response.totalPage)
                setNumberOfItems(response.numberOfItems)
                setGameListData([])
                response.data.map((item, index) => {
                    setGameListData(prevState => [
                        ...prevState,
                        gameTablePreparation(
                            (page * size) + index + 1,
                            item.id,
                            item.thumbnail && item.thumbnail.downloadUrl ? item.thumbnail.downloadUrl : gameThumbnail,
                            item.title,
                            item.playMode,
                            item.status,
                            item.createdBy,
                            item.createdAt,
                        )
                    ])
                })
            }).catch(reason => {
            showServerErrorMessage(reason)
        }).finally(_ => {
            setTableLoading(false)
        })

    }

    function handleChangePage(newPage) {
        page = newPage;
        getGamesListFromServer()
    }

    function handleDeleteAllFilters() {
        setStatus(GameStatusTypes.ALL.id)
        setPlayMode(PlayModeTypes.ALL.id)
    }

    const [openAddNewGameDialog, setOpenAddNewGameDialog] = useState(false)

    function handleOpenAddNewGameDialog() {
        setOpenAddNewGameDialog(true)
    }

    function handleCloseAddNewGameDialog() {
        setOpenAddNewGameDialog(false)
    }


    function addNewGameToTable(item) {
        const _items = addNewRowToTable(
            gameTablePreparation(
                1,
                item.id,
                "",
                item.title,
                item.playMode,
                item.status,
                item.createdBy,
                item.createdAt,
            ),
            gameListData
        );
        setGameListData(_items)
    }

    const navigate = useNavigate()

    function handleShowGameDetails(gameId) {
        let _title = ""
        gameListData.map((item) => {
            if (item.id === gameId)
                _title = item.gameTitle
        })
        navigate(RouteHelper.GameDetails.globalUrl.replace(":id", gameId),
            {state: {title: _title}, replace: false}
        )
        // const stage = gameListData.find(
        //     (item) => item.id === gameId
        // );
        //
        // navigate(
        //     RouteHelper.GameDetails.globalUrl
        //         .replace(":id", gameId),
        //     {
        //         state: {
        //             gameTitle: stage?.gameTitle || RouteHelper.GameDetails.name,
        //         },
        //         replace: false
        //     }
        // );
    }

    return (
        <>
            <Helmet><title>{RouteHelper.Games.name}</title></Helmet>
            <RaikoDefaultDialogPage
                pageTitle={""}
                onClose={handleCloseAddNewGameDialog}
                open={openAddNewGameDialog}
                dialogSize={DialogSize.WRAP_CONTENT}
                hasCloseButton={false}
            >
                <AddNewGame
                    handleCloseDialog={handleCloseAddNewGameDialog}
                    handleAddNewGame={addNewGameToTable}
                />

            </RaikoDefaultDialogPage>

            <RaikoBaseContainer>
                <RaikoGridOneColumn>
                    <RaikoBreadcrumb breadCrumbItems={[
                        raikoBreadCrumbItemGenerator(RouteHelper.Game.name, ""),
                        raikoBreadCrumbItemGenerator(RouteHelper.Games.name, ""),
                    ]}/>
                </RaikoGridOneColumn>
                <RaikoBaseCardContainer>
                    <RaikoGridOneColumn>
                        <RaikoTableTitleContainer
                            title={RouteHelper.Games.name}
                            amount={numberOfItems}
                            hasCreateNewItem
                            handleCreateNewItem={handleOpenAddNewGameDialog}
                            hasSelectDisplayType
                            selectDisplayType={selectDisplayType}
                            setSelectDisplayType={setSelectDisplayType}
                        />
                        <RaikoTableSearchContainer
                            labelText={"عنوان بازی"}
                            hasFilter
                            value={gameTitle}
                            setValue={setGameTitle}
                            handleDeleteAllFilters={handleDeleteAllFilters}
                            filterStatus={
                                status.length > 0 && GameStatusTypes.ALL.id !== status ||
                                playMode.length > 0 && PlayModeTypes.ALL.id !== playMode
                            }
                        >
                            <RaikoGridOneColumn>
                                <RaikoCustomSelect
                                    labelText={"نوع بازی"}
                                    value={playMode}
                                    setValue={setPlayMode}
                                    items={[
                                        raikoCustomSelectItemGenerator(PlayModeTypes.ALL.id, PlayModeTypes.ALL.title),
                                        raikoCustomSelectItemGenerator(PlayModeTypes.MULTI.id, PlayModeTypes.MULTI.title),
                                        raikoCustomSelectItemGenerator(PlayModeTypes.SINGLE.id, PlayModeTypes.SINGLE.title),
                                    ]}
                                />
                                <RaikoCustomSelect
                                    labelText={"وضعیت"}
                                    value={status}
                                    setValue={setStatus}
                                    items={[
                                        raikoCustomSelectItemGenerator(GameStatusTypes.ALL.id, GameStatusTypes.ALL.title),
                                        raikoCustomSelectItemGenerator(GameStatusTypes.PUBLISHED.id, GameStatusTypes.PUBLISHED.title),
                                        raikoCustomSelectItemGenerator(GameStatusTypes.DRAFT.id, GameStatusTypes.DRAFT.title),
                                        raikoCustomSelectItemGenerator(GameStatusTypes.ARCHIVED.id, GameStatusTypes.ARCHIVED.title),
                                        raikoCustomSelectItemGenerator(GameStatusTypes.SUSPENDED.id, GameStatusTypes.SUSPENDED.title),
                                    ]}

                                />
                            </RaikoGridOneColumn>

                        </RaikoTableSearchContainer>
                        <RaikoCustomTable
                            header={gamesListHeader}
                            data={gameListData}
                            selectDisplayType={selectDisplayType}
                            isLoading={tableLoading}
                            pageCount={pageCount}
                            handlePaginationChange={handleChangePage}
                            rowClicked={handleShowGameDetails}
                        >
                            <RaikoGridThreeColumn className={css`padding: 3px`}>
                                {
                                    gameListData.map((item, index) => {
                                        return <RaikoCardInfoTypeOne
                                            key={index}
                                            title={item.gameTitle}
                                            titleLabel={item.playMode}
                                            status
                                            statusType={
                                                item.statusPlace === GameStatusTypes.PUBLISHED.id ?
                                                    RaikoCardInfoTypeOneStatusTypes.SUCCESS :
                                                    item.statusPlace === GameStatusTypes.SUSPENDED.id ?
                                                        RaikoCardInfoTypeOneStatusTypes.ERROR :
                                                        RaikoCardInfoTypeOneStatusTypes.WARNING
                                            }
                                            statusText={item.statusPlace === GameStatusTypes.PUBLISHED.id ?
                                                GameStatusTypes.PUBLISHED.title :
                                                item.statusPlace === GameStatusTypes.DRAFT.id ?
                                                    GameStatusTypes.DRAFT.title :
                                                    item.statusPlace === GameStatusTypes.ARCHIVED.id ?
                                                        GameStatusTypes.ARCHIVED.title :
                                                        GameStatusTypes.SUSPENDED.title
                                            }
                                            hasAvatar
                                            avatarSource={item.gameThumbnail}
                                            items={[
                                                RaikoCardInfoTypeOneItemGenerator("سازنده", item.createdBy),
                                                RaikoCardInfoTypeOneItemGenerator("تاریخ ساخت", item.createdAt)
                                            ]}
                                            onClick={() => {
                                                handleShowGameDetails(item.id)
                                            }}
                                        />
                                    })
                                }
                            </RaikoGridThreeColumn>


                        </RaikoCustomTable>
                    </RaikoGridOneColumn>
                </RaikoBaseCardContainer>
            </RaikoBaseContainer>


        </>
    )
}

const gamesListHeader = [
    {
        id: "number",
        label: "#",
    },
    {
        id: "thumbnail",
        label: "تصویر"
    },
    {
        id: "gameTitle",
        label: "عنوان بازی"
    },
    {
        id: "playMode",
        label: "نوع بازی"
    },
    {
        id: "status",
        label: "وضعیت"
    },
    {
        id: "createdBy",
        label: "سازنده"
    },
    {
        id: "createdAt",
        label: "تاریخ ساخت"
    },
]

function gameTablePreparation(number, id, thumbnail, gameTitle, playMode, status, createdBy, createdAt) {

    let statusChip

    if (status === GameStatusTypes.PUBLISHED.id) {
        statusChip = <RaikoCustomSimpleChip title={getGameStatus(status)} type={RaikoChipTypes.success}/>
    } else if (status === GameStatusTypes.DRAFT.id || GameStatusTypes.ARCHIVED.id) {
        statusChip = <RaikoCustomSimpleChip title={getGameStatus(status)} type={RaikoChipTypes.warning}/>
    } else if (status === GameStatusTypes.SUSPENDED.id) {
        statusChip = <RaikoCustomSimpleChip title={getGameStatus(status)} type={RaikoChipTypes.error}/>
    }


    return {
        number,
        id,
        gameThumbnail: thumbnail,
        thumbnail: <img
            src={thumbnail}
            className={css`
                border-radius: 8px;
                width: 50px;
                height: 50px;
                aspect-ratio: 1/1;
                object-fit: cover;
            `
            }
            alt=""/>,
        gameTitle,
        playMode: playMode === 'SINGLE' ? "انفرادی" : "گروهی",
        status: statusChip,
        statusPlace: status,
        createdBy,
        createdAt: convertUniversalDateToPersianDate(createdAt)
    }

}


